import React, { useEffect, useRef } from "react";
import { useTutorials } from "_shared/tutorials/tutorial-provider";
import type { TutorialTargetId } from "_shared/tutorials/tutorial-types";

export default function TutorialTarget(props: {
  readonly id: TutorialTargetId;
  readonly children: React.ReactNode;
  readonly enabled?: boolean;
}) {
  const { id, children } = props;
  const enabled = props.enabled ?? true;
  const elementRef = useRef<HTMLSpanElement>(null);
  const { registerTarget } = useTutorials();

  useEffect(() => {
    const child = elementRef.current?.firstElementChild;
    registerTarget(id, enabled ? ((child as HTMLElement | null) ?? elementRef.current) : null);
    return () => registerTarget(id, null);
  }, [enabled, id, registerTarget]);

  return <span ref={elementRef} style={{ display: "contents" }}>{children}</span>;
}
